import { render, staticRenderFns } from "./LocationBIcon.vue?vue&type=template&id=72624b24"
import script from "./LocationBIcon.vue?vue&type=script&lang=js"
export * from "./LocationBIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports